export default __webpack_public_path__ + "static/media/hair4.197a84e6.png";